import React, {Component} from 'react'
import {CardHeader, CardBody, Button} from 'reactstrap'
import {graphql, compose, withApollo} from 'react-apollo'
import {createOrUpdateCommentsMutation, destroyCommentMutation, CommentsFetchQuery} from './mutations'
import PropTypes from 'prop-types'
import {getUserPermissions} from '../../utils/userPermissions'
import BlockWithLoader from '../Support/BlockWithLoader'
import ConfirmModal from '../Alerts/ConfirmModal'
import CommentBox from './CommentBox'

const propTypes = {
  client: PropTypes.object.isRequired,
  createOrUpdateCommentsMutation: PropTypes.func.isRequired,
  destroyCommentMutation: PropTypes.func.isRequired,
  commentableId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  commentableType: PropTypes.string.isRequired,
}

const defaultProps = {
  commentableId: null
}

class Comments extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
      commentsList: [],
      commentIdRemove: null,
      validation_errors: null
    }

    this.onDestroy = this.onDestroy.bind(this)
    this.onSave = this.onSave.bind(this)
    this.onAddNew = this.onAddNew.bind(this)
    this.onEditToggle = this.onEditToggle.bind(this)
    this.onChange = this.onChange.bind(this)
  }

  componentWillMount() {
    if (this.props.commentableId) {
      this.setState({isLoading: true})
      this.props.client.query({
        query: CommentsFetchQuery,
        fetchPolicy: 'network-only',
        variables: {
          commentable_id: this.props.commentableId,
          commentable_type: this.props.commentableType
        }
      }).then(({data}) => {
        this.setState({isLoading: false, commentsList: data.comments.slice(0)})
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    // Force save all comments on parent object save
    if (!this.props.commentableId && nextProps.commentableId) {
      this.state.commentsList.forEach((o, idx) => this.onSave(idx, false, nextProps.commentableId))
    }
  }

  onChange(index, val) {
    let newCommentsList = this.state.commentsList
    newCommentsList[index].comment = val
    this.setState({commentsList: newCommentsList})
  }

  onDestroy(index) {
    let commentId = this.state.commentsList[index].id
    if (commentId) {
      this.setState({commentIdRemove: commentId})
    } else {
      let newCommentsList = this.state.commentsList
      newCommentsList.splice(index, 1)
      this.setState({commentsList: newCommentsList})
    }
  }

  removeComment(id) {
    this.props.destroyCommentMutation({
      variables: {id: id}
    }).then(() => {
      let newCommentsList = this.state.commentsList.filter(function (item) {
        return (item.id !== id)
      })
      this.setState({commentsList: newCommentsList, commentIdRemove: null})
    })
  }

  onSave(idx, setState = true, commentableId = null) {
    let comment = this.state.commentsList[idx]
    this.props.createOrUpdateCommentsMutation({
      variables: {
        id: comment.id ? comment.id : null,
        commentable_id: this.props.commentableId || commentableId,
        commentable_type: this.props.commentableType,
        comment: comment.comment
      }
    }).then(({data: {createOrUpdateComment}}) => {
      if (createOrUpdateComment.errors) {
        this.setState({validation_errors: createOrUpdateComment.errors})
      } else {
        if (setState) {
          let newCommentsList = this.state.commentsList
          newCommentsList[idx] = createOrUpdateComment.comment
          this.setState({commentsList: newCommentsList})
        }
      }
    })
  }

  onAddNew() {
    let newCommentsList = this.state.commentsList
    newCommentsList.unshift({id: null, edit: true, comment: ''})
    this.setState({commentsList: newCommentsList})
  }

  onEditToggle(idx) {
    let newCommentsList = this.state.commentsList
    newCommentsList[idx] = {...newCommentsList[idx], edit: !newCommentsList[idx].edit}
    this.setState({commentsList: newCommentsList})
  }

  renderList() {
    return this.state.commentsList.map((comment, index) => (
      <CommentBox
        key={index}
        index={index}
        comment={comment}
        toEdit={comment.edit || false}
        onChangeFunction={this.onChange}
        onEditToggleFunction={this.onEditToggle}
        onDestroyFunction={this.onDestroy}
        onSaveFunction={this.onSave}
        showSaveBtn={!!this.props.commentableId}
      />
    ))
  }

  render() {
    return (
      <BlockWithLoader loading={this.state.isLoading} renderChildren={true}>
        <ConfirmModal
          isOpened={!!this.state.commentIdRemove}
          onCancel={() => this.setState({commentIdRemove: null})}
          onConfirm={() => this.removeComment(this.state.commentIdRemove)}
          headerText='Remove Comment'
          bodyText='Are you sure you want to delete this comment?'
          confirmBtnText='Remove'
        />
        <CardHeader>{'Comments '}
          {getUserPermissions('core.comments.create') &&
          <Button size="sm" color="primary" onClick={this.onAddNew}><i className="fa fa-plus"/> Add new</Button>}
        </CardHeader>
        <CardBody>
          {this.state.validation_errors &&
          <h4 className="errors-heading">{this.state.validation_errors.join(', ')}</h4>}
          {this.renderList()}
        </CardBody>
      </BlockWithLoader>
    )
  }
}

Comments.propTypes = propTypes
Comments.defaultProps = defaultProps

const CommentsWithData = compose(
  graphql(createOrUpdateCommentsMutation, {name: 'createOrUpdateCommentsMutation'}),
  graphql(destroyCommentMutation, {name: 'destroyCommentMutation'})
)(Comments)

export default withApollo(CommentsWithData)



// WEBPACK FOOTER //
// ./src/components/Comments/Comments.js